// extracted by mini-css-extract-plugin
export default {"advertDetailService__label":"c-p_fS","advertDetailService__price":"c-p_fT"};